import { Text } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { MediaButton, MediaButtonContainer } from './MediaButton'

export const BraLiftButton = () => {
  const { t } = useTranslation()

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    document.getElementById('bra-lift')?.scrollIntoView()
  }

  return (
    <MediaButtonContainer data-testid="bra-lift-media-button">
      <MediaButton onClick={handleClick}>
        <Text variant="body-xs">{t('product.view_pushup_level')}</Text>
      </MediaButton>
    </MediaButtonContainer>
  )
}
